module.exports = __webpack_public_path__ + "fwm_h5/img/315_3.b7c9f646.png";